import React from 'react';
import './SvipBadge.css';
export function SvipBadge({small=false}:{small?:boolean}){return <span className={`svip-gold-badge${small?' svip-gold-badge-small':''}`} style={{'--svip-mask':"url('/assets/ui/vip/svip-crowned-f9d7fc984571.png')"} as React.CSSProperties} title="SVIP"><img src="/assets/ui/vip/svip-crowned-f9d7fc984571.png" alt="SVIP"/></span>;}
